export default __webpack_public_path__ + "static/media/BevNET-Logo.c50fdca9.svg";